module.exports = __webpack_public_path__ + "static/media/CL 2.d55948ec.mp3";